import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal, ModalContent, ModalHeader } from "semantic-ui-react";

import { AddPinPendingChecklist, SortableList } from "modules/PendingChecklistsDashboard/components/PinChecklists/components/PinChecklistModal/components";
import "modules/PendingChecklistsDashboard/components/PinChecklists/components/PinChecklistModal/PinChecklistModal.scss";

import type { UniqueIdentifier } from "@dnd-kit/core";
import type { Checklist, PIN_TYPES, PinPendingChecklist } from "models";
import type { PinPendingChecklistsByPinType } from "modules/PendingChecklistsDashboard/components/PinChecklists/hooks";

export type SortablePinPendingChecklists = { id: UniqueIdentifier } & PinPendingChecklist;

type PendingChecklistsProps = {
  pinType: PIN_TYPES | null;
  onClose: () => void;
  checklists?: Checklist[];
  pinPendingChecklistsGroupedByPinType?: PinPendingChecklistsByPinType[];
};

export const PinChecklistModal = ({ onClose, pinPendingChecklistsGroupedByPinType, pinType, checklists }: PendingChecklistsProps) => {
  const { t } = useTranslation();

  const [sortablePinPendingChecklists, setSortablePinPendingChecklists] = useState<SortablePinPendingChecklists[]>([]);

  const selectedPinTypeDetails = pinPendingChecklistsGroupedByPinType?.find(({ pin_type }) => pin_type === pinType);

  useEffect(() => {
    const selectedPinTypeChecklists = selectedPinTypeDetails?.checklists ?? [];

    if (selectedPinTypeChecklists.length) {
      const offset = selectedPinTypeChecklists.length;
      setSortablePinPendingChecklists(selectedPinTypeChecklists.map(pc => ({ ...pc, id: offset + pc.ordering })));
      return;
    }

    setSortablePinPendingChecklists([]);
  }, [pinType, selectedPinTypeDetails]);

  return (
    <Modal open={Boolean(pinType)} closeOnDimmerClick={false} onClose={onClose} className="PinChecklistModal">
      <ModalHeader className="header-container">
        {t("v8_add_checklists_to", "Add Checklists to")} {selectedPinTypeDetails?.title || ""}
        <div className="close-btn">
          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark grey" />
          </Button>
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="sortable-list-container">
          <SortableList
            checklists={checklists}
            sortablePinPendingChecklists={sortablePinPendingChecklists}
            setSortablePinPendingChecklists={setSortablePinPendingChecklists}
          />
        </div>
        <AddPinPendingChecklist pinType={pinType} items={sortablePinPendingChecklists} checklists={checklists} nextOrdering={sortablePinPendingChecklists.length + 1} />
      </ModalContent>
    </Modal>
  );
};
